"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var forms_1 = require("@angular/forms");
var lang_1 = require("../util/lang");
exports.base64 = function (control) {
  if (lang_1.isPresent(forms_1.Validators.required(control))) return null;
  var v = control.value;
  return /^(?:[A-Z0-9+\/]{4})*(?:[A-Z0-9+\/]{2}==|[A-Z0-9+\/]{3}=|[A-Z0-9+\/]{4})$/i.test(v) ? null : {
    'base64': true
  };
};
